const UserTypesEnum = {
  PRO: "Pro",
  BASIC: "Basic",
  GUEST: "Guest",
};
  
export default UserTypesEnum;